import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { MenuItem, Select, TextField, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { useEffect, useState } from 'react';
import { Tournament } from '../../models/Tournament';
import { getChampions, IndividualTrophy, TrophyType } from '../../services/TournamentService';
import { getTrophyEmoji } from '../../utils/Icons';

interface IndividualTrophiesDialogsProps {
  tournament: Tournament;
  onClose: () => void;
  onSave: () => void;
}

export const IndividualTrophiesDialog = ({ tournament, onClose, onSave }: IndividualTrophiesDialogsProps) => {
  const [individualTrophies, setIndividualTrophies] = useState<IndividualTrophy[]>([]);
  const [newTrophy, setNewTrophy] = useState<IndividualTrophy>({ type: TrophyType.Shooter, player: '' });
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  useEffect(() => {
    getChampions(tournament.id).then((response) => {
      setIndividualTrophies(response.individualTrophies);
    });
  }, []);

  const handleSave = () => {};

  return (
    <>
      <Dialog open fullWidth>
        <DialogTitle sx={{ m: 0, p: 2 }}>Indywidualne wyróżnienia turnieju: {tournament.name}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => onClose()}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {individualTrophies.length > 0 ? (
            individualTrophies.map((trophy, index) => (
              <div key={'trophy' + index}>
                {getTrophyEmoji(trophy.type)} - {trophy.player}
              </div>
            ))
          ) : (
            <Typography>Brak wyróżnień</Typography>
          )}
          <Button variant="contained" endIcon={<AddIcon />} onClick={() => setDialogOpen(true)}>
            Dodaj
          </Button>
        </DialogContent>
      </Dialog>
      <Dialog open={dialogOpen}>
        <DialogTitle sx={{ m: 0, p: 2 }}>Nowe wyróżnienie</DialogTitle>
        <DialogContent>
          <Select
            value={newTrophy.type}
            onChange={(e) => setNewTrophy((prev) => ({ ...prev, type: e.target.value as TrophyType }))}
            fullWidth
          >
            <MenuItem value={TrophyType.Shooter}>{getTrophyEmoji(TrophyType.Shooter)} - Najlepszy Strzelec</MenuItem>
            <MenuItem value={TrophyType.Goalkeeper}>{getTrophyEmoji(TrophyType.Goalkeeper)} - Najlepszy Bramkarz</MenuItem>
            <MenuItem value={TrophyType.MVP}>{getTrophyEmoji(TrophyType.MVP)} - MVP Turnieju</MenuItem>
          </Select>
          <TextField
            fullWidth
            sx={{ mt: 2 }} // Added margin-top for spacing
            value={newTrophy.player}
            onChange={(e) => setNewTrophy((prev) => ({ ...prev, player: e.target.value }))}
            label="Zawodnik"
            placeholder="Wpisz imię i nazwisko zawodnika"
          />{' '}
        </DialogContent>
        <DialogActions>
          <Button autoFocus variant="contained" onClick={handleSave}>
            ZAPISZ
          </Button>
          <Button variant="outlined" onClick={() => setDialogOpen(false)}>
            ANULUJ
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
